import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LoginViewProps } from './LoginTypes';
import { loadContextMethods } from './LoginContextLoader';


export const LoginView: React.FC<LoginViewProps> = ({ setError }) => {
    const { t } = useTranslation();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [tfaCode, setTfaCode] = useState('');
    const [tfaLogin, setTfaLogin] = useState(false);

    const { login, loginWithTFA, navigateTo } = loadContextMethods();

    const handleOfficeLogin = () => {
        // Redirect to backend Office 365 login initiation endpoint
        window.location.href = '/api/auth/ms-login';
    };

    const handleLogin = async () => {
        setError(null);
        const response = await login(username, password);
        if (response.mfaEnabled) {
            setTfaLogin(true);
            return;
        } else if (response.success) {
            navigateTo('/home');
        } else {
            setError(t("login_error_username_password"));
        }
    };

    const handleTfaLogin = async () => {
        setError(null);
        const response = await loginWithTFA(username, password, tfaCode);
        if (response.success) {
            navigateTo('/home');
        } else {
            setError(t("login_error_tfa"));
        }
    };

    return (
        <div className="login-form">
            {!tfaLogin ? (
                <>
                    <input
                        type="text"
                        placeholder="E-Mail Addresse"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        className="login-input"
                    />
                    <input
                        type="password"
                        placeholder="Passwort"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="login-input"
                    />
                    <button className="login-button" onClick={handleLogin}>
                        Login
                    </button>
                    <div style={{ margin: '24px 0', width: '100%' }}>
                        <hr style={{ marginBottom: '16px' }} />
                        <button
                            className="microsoft-login-button"
                            onClick={handleOfficeLogin}
                            aria-label="Login mit Microsoft Office 365"
                        >
                            {/* Simple Microsoft logo (4 colored squares) */}
                            <span style={{ display: 'flex', width: 20, height: 20 }} aria-hidden="true">
                                <span className="microsoft-logo-square" style={{ background: '#F25022' }} />
                                <span className="microsoft-logo-square" style={{ background: '#7FBA00', marginLeft: 2 }} />
                                <span className="microsoft-logo-square" style={{ background: '#00A4EF', marginLeft: 2 }} />
                                <span className="microsoft-logo-square" style={{ background: '#FFB900', marginLeft: 2 }} />
                            </span>
                            <span>Login mit Microsoft Account</span>
                        </button>
                    </div>
                </>
            ) : (
                <>
                    <input
                        type="text"
                        placeholder={t("login_token")}
                        value={tfaCode}
                        onChange={(e) => setTfaCode(e.target.value)}
                        className="login-input"
                    />
                    <button className="login-button" onClick={handleTfaLogin}>
                        {t("login_tfa")}
                    </button>
                </>
            )}
        </div>
    )
};